// Captures lead source + UTM params from the URL on first visit and persists them
// so any form submission can attribute the lead correctly.
const KEY = 'mmt_attribution';

const SOURCE_MAP = {
  google: 'Google Ads',
  facebook: 'Facebook',
  fb: 'Facebook',
  instagram: 'Instagram',
  ig: 'Instagram',
  whatsapp: 'WhatsApp',
  referral: 'Referral',
};

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const existing = getAttribution();
    const utm = {
      utm_source: params.get('utm_source') || existing.utm_source || '',
      utm_medium: params.get('utm_medium') || existing.utm_medium || '',
      utm_campaign: params.get('utm_campaign') || existing.utm_campaign || '',
      utm_content: params.get('utm_content') || existing.utm_content || '',
      utm_term: params.get('utm_term') || existing.utm_term || '',
    };
    let source = existing.source || '';
    if (!source) {
      const us = (utm.utm_source || '').toLowerCase();
      if (us && SOURCE_MAP[us]) source = SOURCE_MAP[us];
      else if (utm.utm_source) source = 'Google Ads';
      else if (document.referrer) {
        const ref = document.referrer.toLowerCase();
        if (ref.includes('google')) source = 'Google Organic';
        else if (ref.includes('facebook')) source = 'Facebook';
        else if (ref.includes('instagram')) source = 'Instagram';
        else source = 'Referral';
      } else {
        source = 'Direct Website';
      }
    }
    const data = { ...utm, source };
    sessionStorage.setItem(KEY, JSON.stringify(data));
    return data;
  } catch {
    return { source: 'Direct Website', utm_source: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '' };
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

// Appends source + UTM fields to a FormData instance. `defaultSource` overrides
// the tracked source for form-specific sources (e.g. Emergency Services).
export function appendAttribution(formData, defaultSource) {
  const a = getAttribution();
  formData.append('source', defaultSource || a.source || 'Direct Website');
  formData.append('utm_source', a.utm_source || '');
  formData.append('utm_medium', a.utm_medium || '');
  formData.append('utm_campaign', a.utm_campaign || '');
  formData.append('utm_content', a.utm_content || '');
  formData.append('utm_term', a.utm_term || '');
  return formData;
}
